<template>
    <!-- 下载书签提示 -->
    <div v-show="store.state.isShowPWA" class="download-content display-y-center display-s-b">
        <img class="close" src="@/assets/images/common/btn_close.png" @click="onClosePWA" />
        <!-- <div class="text">{{ t("home.24") }}</div> -->
        <!-- <div class="btn" @click="onDownload">{{ t("home.25") }}</div> -->
    </div>
    <Header v-if="route.meta.showHeader" />
    <router-view />
    <Navbar v-if="route.meta.showNavbar" />
    <!--测试模式检查-->
    <CheckDebug />
    <!-- iframe -->
    <Iframe v-if="store.state.gameUrl" :href="store.state.gameUrl" :newStyle="'display: block !important;'" />
    <!-- 新用户专属奖励弹窗 -->
    <NewPlayerTip v-if="store.state.isShowNewPlayer" @onClose="store.state.isShowNewPlayer = false"></NewPlayerTip>
    <!-- 通用弹窗 -->
    <Alert />
    <!-- 充值返现激活弹窗提示 -->
    <NewPlayerTips v-if="store.state.isShowCashBackProp" />
    <!-- 从游戏退出 未充值玩家金额达到限制 A版弹窗 -->
    <CashBackTip :visible="isCanShowCashBackTip()" />
    <!-- 玩家是否禁用 -->
    <TipDefault v-if="store.state.isUserDisbale" :title="t('common.1')" :isShowClose="false">
        <div class="user-disbale-content">
            {{ t("common.22") }}
        </div>
    </TipDefault>

    <div v-show="store.state.isShowMaskBg" class="mask-bg item-center">
        <img src="@/assets/images/loading.gif" class="item-center" />
    </div>
</template>

<script lang="ts" setup>
import CheckDebug from '@/components/common/CheckDebug.vue';
import TipDefault from '@/components/popup/TipDefault.vue';
import Iframe from "@/components/common/Iframe.vue"
import Header from '@/components/common/Header.vue'
import Navbar from '@/components/common/Navbar.vue'
import NewPlayerTip from '@/components/popup/NewPlayerTip.vue'
import { getLinkParams } from '@/utils/function';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';
import { onBeforeMount, onMounted } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { LOCAL_STORE, USER_TYPE } from './config/constConfig';
import NewPlayerTips from './views/activitys/cashBack/tip/NewPlayerTips.vue';
import CashBackTip from './components/popup/CashBackTip.vue';
import Alert from './components/popup/Alert.vue';

const store = useStore();
const router = useRouter();
const route = useRoute();
const { t } = useI18n();

onBeforeMount(() => {
    initUrlParams();
});

onMounted(() => {
    checkLogin();
});

const initUrlParams = () => {
    const params = getLinkParams();
    store.state.code = params.get("code");
};

function onClosePWA() {
    store.state.isShowPWA = false;
    localStorage.setItem(LOCAL_STORE.IS_DOWN_PWA, "1");
}

/**是否显示提示界面 */
function isCanShowCashBackTip(): boolean {
    if (store.state.userType == USER_TYPE.A && store.state.isShowCashBackTip 
        && (store.state.accountInfo.vipLevel == 0 || store.state.accountInfo.withdrawNum == 1)) {
        return true;
    }
    return false;
}

function onDownload() {
    store.state.deferredPrompt.prompt(); // 触发安装提示
    store.state.deferredPrompt.userChoice.then((choiceResult: any) => {
      if (choiceResult.outcome === 'accepted') {
        localStorage.setItem(LOCAL_STORE.IS_DOWN_PWA, "1");
      } else {
        console.log('User dismissed the A2HS prompt')
      }
      store.state.deferredPrompt = null; // 重置事件对象
    });
}

/**检测是否登录*/
function checkLogin() {
    if (store.state.isLogin != 1) {
        router.push('/');
    } else {
        let isShow = localStorage.getItem(LOCAL_STORE.IS_SHOW_NEWPLAYER);
        if (isShow != "1") {
            store.state.isShowNewPlayer = true;
        }
    }
}
</script>

<style lang="less">
html {
    background-color: #111111;
    font-size: 1.14px;

    -webkit-user-select: none; /* Chrome, Opera, Safari */
    -moz-user-select: none;    /* Firefox */
    -ms-user-select: none;    /* Internet Explorer/Edge */
    user-select: none;        /* 标准语法 */
}
@media only screen and (max-width: 560px) {
    html {
      font-size: 0.265vw;
    }
    html,
    body {
        ::-webkit-scrollbar {
            width: 0rem !important;
            /* 设置滚动条宽度 */
            height: 0rem !important;
        }
    }
}
@media only screen and (min-width: 560px) {
    html,
    body {
        ::-webkit-scrollbar {
            width: 0rem !important;
            /* 设置滚动条宽度 */
            height: 3rem !important;
        }
        ::-webkit-scrollbar-thumb {
            background-color: #888;
            /* 设置滑块颜色 */
            border-radius: 10px;
            /* 设置滑块圆角 */
        }
    }
}
#app {
    max-width: @max-width;
    height: 100%;
    background-color: #0F1D29;
    overflow: hidden;
    margin: auto;
    &.EG {
        text-align: right;
        direction: rtl;
        flex-direction: row-reverse;
        font-family: 'Noto Sans Arabic'
            ,'Droid Arabic Kufic',
            'Almarai',
            sans-serif;
        .arabic-number {
            direction: ltr;
            unicode-bidi: embed;
        }
    }
}

body {
    font-family: -apple-system, BlinkMacSystemFont, Helvetica Neue, Helvetica,
        Segoe UI, Arial, Roboto, PingFang SC, miui, Hiragino Sans GB,
        Microsoft Yahei, sans-serif !important;
    font-size: 14rem;
}

html,
body {
    height: 100%;
    -webkit-text-size-adjust: 100% !important;
    background: #000 !important;
}

.prop-content {
    min-height: 104rem;
    background-color: #1A1B20;
    border-radius: 5rem;
    padding: 10rem;
    box-sizing: border-box;
    color: #FFF;
    line-height: 16rem;
    letter-spacing: 0.5rem;
}

* {
    padding: 0;
    margin: 0;
}
.cash-back-content {
    width: 100%;
    padding: 5rem 10rem 10rem;
    box-sizing: border-box;
    .content-text-bg {
        width: 100%;
        padding: 10rem;       
        box-sizing: border-box;
        background-color: #35383C;
        border-radius: 5rem;
        color: rgba(255, 255, 255, .5);
        white-space: pre-wrap;
        font-size: 13rem;
    }
    .btn {
        width: 237rem;
        height: 36rem;
        background-color: #E8770F;
        border-radius: 5rem;
        margin-top: 15rem;
        text-align: center;
        line-height: 36rem;
        font-size: 14rem;
        color: #FFF;
    }
}
.download-content {
    width: 100%;
    max-width: @max-width;
    height: 40rem;
    background-color: #23252A;
    padding: 5rem 10rem;
    box-sizing: border-box;
    position: absolute;
    top: 0;
    color: #FFF;
    .close {
        width: 20rem;
    }
    .text {
        font-size: 11rem;
        font-weight: bold;
    }
    .btn {
        width: 88rem;
        height: 24rem;
        border-radius: 33rem;
        background: linear-gradient(180deg, #F16720, #FFC320);
        text-align: center;
        line-height: 24rem;
    }
}

.user-disbale-content {
    text-align: center;
    margin: 20rem 10rem 30rem;
    padding: 20rem 10rem;
    box-sizing: border-box;
    background-color: #474747;
    border-radius: 5rem;
    color: #FFF;
    font-size: 15rem;
    font-weight: bold;
}

/* 过渡控制 */
.scale-enter-active,
.scale-leave-active {
  transition: transform 0.3s ease, opacity 0.3s ease;
}
.scale-enter-from {
  transform: scale(0);
  opacity: 0;
}
.scale-enter-to {
  transform: scale(1);
  opacity: 1;
}

.scale-leave-from {
  transform: scale(1);
  opacity: 1;
}
.scale-leave-to {
  transform: scale(0);
  opacity: 0;
}
</style>
<style lang="less" scoped>
.tip-content {
    position: absolute;
    width: calc(100% - 20rem);
    height: auto;
    background-color: #23252A;
    border-radius: 5rem;
    box-sizing: border-box;
    .title {
        color: #FFF;
        font-size: 24rem;
        >span {
            margin-top: 65rem;
        }
        >img {
            width: 127rem;
            position: absolute;
            top: -50rem;
        }
        .tip-icon-1 {
            width: 166rem;
            top: -90rem;
        }
    }
}
&.tip-1 {
    white-space: pre-wrap;
    padding: 80rem 10rem 20rem;
    color: #FFF;
    .content-bg {
        width: 100%;
        padding: 15rem 10rem;
        box-sizing: border-box;
        background-color: #1F2126;
        border-radius: 5rem;
    }
    .btn-1 {
        margin-top: 15rem;
        width: 285rem;
        height: 48rem;
        background-color: #26282D;
        border-radius: 10rem;
        margin-left: 50%;
        transform: translateX(-50%);
        .amount {
            font-size: 20rem;
            font-weight: bold;
            color: #96FF66;
        }
        .amount-des {
            font-size: 12rem;
            color: #7E8187;
        }
    }
    .btn-2 {
        margin-top: 15rem;
        width: 237rem;
        height: 36rem;
        background: #E8770F;
        border-radius: 5rem;
        margin-left: 50%;
        transform: translateX(-50%);
        
    }
    .title {
        width: 100%;
        height: 47rem;
        position: absolute;
        top: 0;
        left: 0;
        background-color: #2E3137;
        &.title-1 {
            background-color: #23252A;
        }
    }
    .icons {
        margin-top: 10rem;
        gap: 40rem;
        .vip-icon-1 {
            width: 58rem;
        }
        .vip-icon-2 {
            width: 46rem;
        }
        .vip-icon-3 {
            width: 74rem;
        }
        .vip1-text {
            color: rgba(255, 255, 255, .5);
        }
    }
}
.btn-close {
    width: 30rem;
    height: 30rem;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: -50rem;
    &.cash1 {
        bottom: 0;
    }
}
.mask-bg {
    z-index: 1000000;
    width: 100%;
    height: 100%;
    background-color: #000;
    position: fixed;

    >img {
        width: 50rem;
        position: fixed;
    }
}
</style>